<template>
    <div>

        <div class="headView_top" style="margin-bottom: 30px;margin-left: 80%">
            <div class="headView_top_btn" v-if="allSubmit">
                <button type="button" @click="upShow('tips')">确认提交</button>
                <div class="btnTips">
                    <img src="../../assets/img/login/注释.png" style="width: 18px;height: 18px;">
                    <p>一旦提交，不可修改，请谨慎操作</p>
                </div>
            </div>
        </div>
       <!-- <div class="headClass">
            <p>项目类型：{{basicParams.project_type_name}}</p>
            <p>申请时间：{{basicParams.apply_start}}-{{basicParams.apply_end}}</p>
            <p>审核时间：{{basicParams.app_start}}-{{basicParams.app_end}}</p>
        </div>-->

        <div class="content_view">
            <div class="contentLeft">
                <p v-for="(item,index) in navList" :key="index" @click="changeTab(index)"
                   :class="navIndex === index?'tabActive':''">
                    {{item}}
                </p>
            </div>
            <div class="contentRight">




               <!-- <div v-show="navIndex === 1">
                    <p class="view_head">评选办法</p>
                    &lt;!&ndash; pdf &ndash;&gt;
                    <div style="height: 650px;overflow-y: scroll">
                        <pdfVue v-if="selection_pdf_url" :pdf_url="selection_pdf_url"></pdfVue>

                    </div>

                    <div style="margin-bottom: 5px;text-align: center;margin-top: 5px">
                        <el-button :type="primary" @click="doReady2" :disabled="disabled">{{btnContent}}</el-button>
                    </div>

                </div>
-->
                <div v-show="navIndex === 0">
                    <p class="view_head">
                        工法基本信息
                    </p>

                    <!-- 诚信企业 -->
                    <addGfBasicMsg  :basicMsg="basicMsg" @basicInfo="getBasicInfo"></addGfBasicMsg>

                </div>


                <div v-show="navIndex == 1" >

                    <p class="view_head">第一完成单位</p>

                    <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
                        <labelInput :outInput="newform.name"  normalPlace="请输入"
                                    @inputChange="labelInput($event,'name')"
                                    spanTitle="单位名称" :spanWidth="spanWidth" componentWidth="520px">
                        </labelInput>

                        <labelInput :outInput="newform.tax_number"  normalPlace="请输入"
                                    @inputChange="labelInput($event,'tax_number')"
                                    spanTitle="社会统一信用代码" :spanWidth="spanWidth" componentWidth="520px">
                        </labelInput>

                        <labelInput :outInput="newform.register_address" normalPlace="请输入"
                                    @inputChange="labelInput($event,'register_address')"
                                    spanTitle="单位注册地" :spanWidth="spanWidth" componentWidth="520px"
                                   >
                        </labelInput>

                        <labelInput :outInput="newform.address" normalPlace="请输入"
                                    @inputChange="labelInput($event,'address')"
                                    spanTitle="通信地址" :spanWidth="spanWidth" componentWidth="520px"
                                    >
                        </labelInput>

                        <labelInput :outInput="newform.qualification_level"  normalPlace="请输入"
                                    @inputChange="labelInput($event,'qualification_level')"
                                    spanTitle="企业资质等级" :spanWidth="spanWidth" componentWidth="520px"
                        >
                        </labelInput>

                        <labelInput :outInput="newform.site_url" normalPlace="请输入"
                                    @inputChange="labelInput($event,'site_url')"
                                    spanTitle="企业网址" :spanWidth="spanWidth" componentWidth="520px"

                        >
                        </labelInput>

                        <labelInput :outInput="newform.legal_person"  normalPlace="请输入"
                                    @inputChange="labelInput($event,'legal_person')"
                                    spanTitle="法人代表" :spanWidth="spanWidth" componentWidth="520px"

                        >
                        </labelInput>

                        <labelInput :outInput="newform.cellphone"  normalPlace="请输入"
                                    @inputChange="labelInput($event,'cellphone')"
                                    spanTitle="手机号码" :spanWidth="spanWidth" componentWidth="520px"
                                    :isPhone="true" specilType='number' :maxLimit="11"
                        >
                        </labelInput>


                        <labelInput :outInput="newform2.username"  normalPlace="请输入"
                                    @inputChange="labelInput2($event,'username')"
                                    spanTitle="联系人" :spanWidth="spanWidth" componentWidth="520px"

                        >
                        </labelInput>

                        <labelInput :outInput="newform3.id_card" :spanRequired="false" normalPlace="请输入"
                                    @inputChange="labelInput3($event,'id_card')"
                                    spanTitle="身份证号" :spanWidth="spanWidth" componentWidth="520px"

                        >
                        </labelInput>

                        <labelInput :outInput="newform2.dep"  normalPlace="请输入"
                                    @inputChange="labelInput2($event,'dep')"
                                    spanTitle="工作部门" :spanWidth="spanWidth" componentWidth="520px"


                        >
                        </labelInput>


                        <labelInput :outInput="newform2.post"  normalPlace="请输入"
                                    @inputChange="labelInput2($event,'post')"
                                    spanTitle="单位职务" :spanWidth="spanWidth" componentWidth="520px"

                        >
                        </labelInput>

                        <labelInput :outInput="newform.phone"  normalPlace="请输入"
                                    @inputChange="labelInput($event,'phone')"
                                    spanTitle="办公电话" :spanWidth="spanWidth" componentWidth="520px"

                        >
                        </labelInput>


                        <labelInput :outInput="newform2.cellphone"  normalPlace="请输入"
                                    @inputChange="labelInput2($event,'cellphone')"
                                    spanTitle="手机号码" :spanWidth="spanWidth" componentWidth="520px"

                        >
                        </labelInput>

                        <labelInput :outInput="newform3.Qq" normalPlace="请输入"
                                    @inputChange="labelInput3($event,'Qq')"
                                    spanTitle="QQ" :spanWidth="spanWidth" componentWidth="520px"

                        >
                        </labelInput>

                        <labelInput :outInput="newform2.email"  normalPlace="请输入"
                                    @inputChange="labelInput2($event,'email')"
                                    spanTitle="电子邮箱 " :spanWidth="spanWidth" componentWidth="520px"

                        >
                        </labelInput>
                    </div>

                    <p class="view_head">第二完成单位</p>


                    <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
                        <labelInput :outInput="newform3.enp_name2"  normalPlace="请输入"
                                      @inputChange="labelInput3($event,'enp_name2')"
                                      spanTitle="单位名称" :spanWidth="spanWidth" componentWidth="520px"
                                      >
                        </labelInput>

                        <labelInput :outInput="newform3.tax_number2"  normalPlace="请输入"
                                    @inputChange="labelInput3($event,'tax_number2')"
                                    spanTitle="社会统一信用代码" :spanWidth="spanWidth" componentWidth="520px"

                        >
                        </labelInput>
                    </div>


                </div>

                <div class="uploadContent" v-show="navIndex === 2">

                    <div>
                        <!--<div class="uploadHead" @click="upShow('muban')">
                            <img src="../../assets/img/main/muban.png" style="width: 20px;height: 20px;">
                            <p>模板下载</p>
                        </div>-->
                        <p class="view_head">资料上传</p>
                        <div class="uploadList" v-for="(item,index) in uploadData.title" :key="index">
                            <div class="uploadList_head">
                                <p>{{item}}</p>
                                <div class="head_list">
                                    <!--<img v-if="index === 0" src="../../assets/img/main/download.png"
                                         style="width: 20px;height: 20px;">-->
                                    <!--<p v-if="index === 0" @click="downLoadFile" style="margin-right: 20px;">点击生成</p>-->
                                    <img src="../../assets/img/main/upload.png" style="width: 20px;height: 20px;">
                                    <p @click="upShow('upload',index)">点击上传</p>
                                </div>
                            </div>
                            <div class="uploadList_mid">
                                <p>{{uploadData.tips[index]}}</p>
                            </div>
                            <div class="uploadList_bot">
                                <div class="inner_upload" v-for="(item,key) in uploadList[index]" :key="key"
                                     @click="showPriv(item)"
                                >
                                    <p><a target="_blank" :href="item.stored_path">{{item.name?item.name:item.data_name}}</a></p>
                                    <img src="../../assets/img/login/cuowu.png" @click.stop="deleteUpload(key,index)">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <div v-show="navIndex === 3">

                    <p class="view_head">申报须知</p>
                    <!-- pdf -->
                    <div style="height: 650px;overflow-y: scroll">
                        <pdfVue v-if="require_pdf_url" :pdf_url="require_pdf_url"></pdfVue>
                    </div>


                    <!-- <div style="margin-bottom: 5px;text-align: center;margin-top: 5px">
                         <el-button :type="primary" @click="doReady" :disabled="disabled">{{btnContent}}</el-button>
                     </div>-->

                </div>

                <!--<
                div v-show="navIndex === 3">
                    <p class="view_head">填写说明</p>

                    <div style="text-align: left;margin-left: 20px">
                        <p class="tip">1.“申报企业”栏：应为工法的第一完成单位。</p>

                        <p class="tip">2.“类别”栏：请在房屋建筑工程、市政公用工程、机电安装工程对应项中划“√”，申报表封面直接填写。</p>

                        <p class="tip">3.“专业分类”栏：</p>

                        <p class="tip">房屋建筑工程类别包括：（1）地基与基础（2）主体结构（3）钢结构（4）装饰与屋面（5）其他；</p>

                        <p class="tip">市政公用工程类别包括：（1）城市道路（2）城市轨道交通（3）隧道（4）桥梁（5）其他；</p>

                        <p class="tip">机电安装工程类别包括：（1）给排水及采暖（2）通风与空调（3）电气装置与自动化（4）其他。</p>

                        <p class="tip">如没有对应专业，请填写“其他”并注明自己认可的专业分类。</p>

                        <p class="tip">4.“工法完成单位”栏：填写内容应与“主要完成单位意见”栏中的公章一致。</p>

                        <p class="tip">5.“通讯地址”及“联系人”：指完成单位的地址和联系人。</p>

                        <p class="tip">6.“主要完成人”栏：最多填写5人。</p>

                        <p class="tip">7.“工法应用工程情况”栏：最少填写2项工程。</p>

                        <p class="tip">8.“工法关键技术名称”栏：由申报单位提炼填写；关键技术未组织审定的工法，组织审定单位和时间可不填写。</p>

                        <p class="tip">9.“工法形成企业技术标准情况”栏：该工法已形成了企业技术标准的，填写此栏，填写内容包含企业技术标准名称、编号和发布时间等。</p>

                        <p class="tip">10.“升级版工法”指原工法超过5年有效期，但其关键技术有所创新，仍具有先进性和较高推广应用价值，重新进行申报的工法。</p>

                         <p class="tip">11.工法关键技术涉及有关专利的，应注明专利号、专利权人、专利许可使用期限、范围、权限、是否有偿使用等内容</p>
                    </div>
                </div>

                -->
            </div>
        </div>

        <div class="uploadBtn" v-show="navIndex == 1">
            <el-button type="primary" @click="basicInfo3">下一步</el-button>
        </div>

        <div class="uploadBtn" v-if="navIndex == 2" style="display: flex;margin-left: 24%">
            <div class="content_btn" style="margin-right: 12px">
                <p>资料上传后请点击保存</p>
            </div>
            <el-button type="primary" @click="downLoadFile">打印申报表</el-button>

            <el-button type="primary" @click="setUploadFile">保存并提交</el-button>

        </div>


        <!-- 弹窗 -->
        <addDialog ref="download" @submitSuccess="submitSuccess"></addDialog>
    </div>
</template>

<script>
    // getUploadFile上传文件附件
    import {
        getManagerInfo,
        getProjectDetail,
        getWinningInfo,
        saveQua,
        sureSubmit,
        getApplyDetail,
        getUploadFile,
        getDataItem,
        getBasicA,
        setBasicProgram,
        setTeamBasicInfo,
        setAdvanceInfo,
        setAdvanceInfoCx,
        setBIMBasicInfo,
        setPersonInfo,
        saveEva,
        setAdvanceInfoGF,
        setAdvanceInfoGfEnp
    } from '../../api/moudles/manager.js'
    import {
        API_DOMAIN
    } from '../../api/api.js'
    import {
        vaildte
    } from '../../utils/validate.js'
    import pdfVue from './components/pdfVue.vue'
    import labelText from '../../components/table/labelText.vue'
    import labelInput from '../../components/table/labelInput.vue'
    import normalPicker from '../../components/table/normalPicker.vue'
    import normalSelect from '../../components/table/normalSelect.vue'
    import addDialog from './components/addDialog.vue'

    import addGfBasicMsg from "./components/addGfBasicMsg"

    export default {
        name: "addGf",
        components: {
            labelInput,
            labelText,
            addDialog,
            pdfVue,
            normalPicker,
            normalSelect,
            addGfBasicMsg
        },
        data(){
            return{

                newform3:{

                    id_card:'',
                    Qq:'',
                    enp_name2:'',
                    tax_number2:'',

                },
                newform:{

                    name:'',
                    tax_number:'',
                    register_address:'',
                    address:'',
                    qualification_level:'',
                    site_url:'',
                    legal_person:'',
                    cellphone:'',

                },

                newform2:{
                    contacts_name:'',
                    dep:'',
                    post:'',
                    phone:'',
                    contacts_phone:'',
                    email:'',

                },

                makeShow:0,
                basicMsg: {},
                awardMsg: [],
                // 质量小组基本信息
                basicInfo_6: {},
                check: false,
                disabled: false,
                // 参建单位
                textarea:'',
                textarea2:'',
                oldAddList: [],
                addList: [
                    // 	{
                    // 	type: '',
                    // 	name: '',
                    // },
                ],

                pdbForm:{
                    basic_quality:'',
                    net_assets:'',
                    project_settle_income:'',
                    growth_rate:'',
                    liability_ratio:'',
                    profit_rate:'',
                    good_msg:'',
                    bad_msg:'',
                    enp_management:'',
                    project_app_num:'',

                },

                isAdd:'',
                // 参建方式
                installList: [
                    [{
                        name: '建设单位',
                        code: '建设单位'
                    }, {
                        name: '设计单位',
                        code: '设计单位'
                    }, {
                        name: '监理单位',
                        code: '监理单位'
                    }, {
                        name: '其他施工单位',
                        code: '其他施工单位'
                    }]
                ],
                projectType: '',
                basicParams: {},
                navIndex: 0,
                newnavIndex: 0,
                primary:'primary',
                spanWidth: '180px',
                navList: [
                    "工法基本信息",
                    "单位基本信息",
                    "资料上传",
                    "申报须知",

                ],
                // 基本信息的
                req_num_code: '',
                project_code: '',
                // 基本信息表单
                levelOne: {},
                // 优质安装工程
                levelThree: {
                    company_name: '',
                    contact_name: '',
                    dep: '',
                    cellphone: '',
                    phone: '',
                    project_name: '',
                    declared_project: '',
                    construc_enp: '',
                    use_enp: '',
                    design_enp: '',
                    supervise_enp: '',
                },
                // 基本信息表单
                formName: {

                    name: '工法名称',
                    category: '类别',
                    major_category: '专业分类',
                    recommend_area: '推荐地区',
                    register_area: '注册地区',
                    is_pro: '升级版工法',
                    content1: '工法关键技术名称、组织审定单位和时间',
                    content2: '工法关键技术获科技成果奖励的情况',
                    content3: '工法形成企业技术标准情况',
                    content4: '升级版工法原工法编号、名称、完成单位及',
                    content5: '工法摘要（300字以内）',
                    content6: '工法关键词',
                    content7: '工法内容简述',
                    content8: '关键技术及保密点',
                    content9: '技术水平和技术难度',
                    content10: '工程应用情况及推广应用前景',
                    content11: '经济效益或社会效益（包括节能和环保效益）',
                    complete_collect: '完成人汇总',


                },
                // 获奖信息
                project_app_num: '',
                award_msg: ['质量获奖情况', '安全文明情况'],
                levelTwo: {
                    awardJson: [{}, {},{},{},{} ]
                },
                // 申报须知
                require_pdf_url: '',
                // 评选办法
                selection_pdf_url: '',
                btnContent:'我已阅读',
                totalTime:15,
                canClick: true, //添加canClick
                // 模板下载列表
                modelList: [],
                // 上传文件列表
                clickIndex: 0,
                uploadList: [],
                // 最终提交
                allSubmit: false,
                // 资料上传内容
                uploadData: '',
                // BIM申报的三个申报单位
                listArray: []
            }
        },

        /*props: {

            projectCode: {
                type: String,
                default: ''
            },
        },*/

        created(){

            this.isAdd  = this.$route.params.isAdd

            if (this.$route.params.isAdd == undefined) {

                this.$router.go(-1)
                return

            }

            if(this.$route.params.isAdd == 1){

               // this.countDown()

                this.getProjectdetail(this.$route.params.projectCode,this.$route.params.isAdd)

                // 绑定project_code
                this.levelOne.project_code = this.$route.params.projectCode
                this.project_code = this.$route.params.projectCode
                this.basicMsg.project_code = this.project_code

            }else{

                this.getProjectdetail(this.$route.params.project_application_id,this.$route.params.isAdd)

            }

            // 获取pdf
            // 模板下载列表
            this.modelList = []//JSON.parse(this.$route.params.distribution_materials)
            // 获取项目类型字段
            const projectType = this.$route.params.type
            console.log('projectType', projectType)
            this.projectType = projectType


            getDataItem({
                data: {
                    type: 8
                },
                success: res => {

                    this.uploadData = res.data
                }
            })
        },

        methods : {

            async savePdbForm(){

                this.pdbForm.project_app_num = this.project_app_num

                await saveEva({
                    data:this.pdbForm,
                    success:res=>{

                        console.log('res',res)

                        if (res.code === 200) {

                            this.$message({
                                type: 'success',
                                message: '保存成功!'
                            });

                        } else {
                            this.$message.error(res.msg)
                        }


                    }
                })

            },

            async personInfo(){
                await setPersonInfo({
                    data:{
                        content:this.textarea,
                        personal_resume2:this.textarea2,
                        project_app_num:this.project_app_num,

                    },
                    success:res=>{

                        console.log('res',res)

                        if (res.code === 200) {

                            this.$message({
                                type: 'success',
                                message: '保存成功!'
                            });

                        } else {
                            this.$message.error(res.msg)
                        }


                    }
                })
            },
            countDown() {
                if (!this.canClick) return  //改动的是这两行代码
                this.canClick = false
                this.btnContent =   '我已阅读' + '('+this.totalTime+'s)'

                this.disabled  = true

                let clock = window.setInterval(() => {
                    this.totalTime--
                    this.btnContent = '我已阅读' + '('+this.totalTime+'s)'
                    if (this.totalTime < 0) {
                        window.clearInterval(clock)
                        this.btnContent = '我已阅读'
                        this.disabled  = false
                        this.totalTime = 15
                        this.canClick = true  //这里重新开启
                    }
                },1000)
            },



            doReady(){
                this.makeShow++
                this.navIndex++

               // this.countDown()

            },

            doReady2(){
                this.makeShow++
                this.navIndex++
            },

            // 下载pdf模板
            downLoadFile() {
                if (!this.project_app_num) {
                    this.$message.error('请先提交基本信息')
                    return
                }
                const url =
                    `${API_DOMAIN}/proapi/down/download-basic-msg?type=${this.projectType}&project_app_num=${this.project_app_num}&project_name=${this.basicParams.project_name}`
                window.open(url)
            },
            moreSelect(e) {
                this.listArray = e
            },
            // 优秀项目经理
            // 获取注册编号
            getreq_num_code(e) {
                this.req_num_code = e
            },
            // 获取质量小组获奖信息
            getAwardInfo(e) {
                const [id, name, value] = e
                if (value === '' || value === null) {
                    delete this.levelTwo.awardJson[id][name]
                } else {
                    this.levelTwo.awardJson[id][name] = value
                }
            },



            getBasicInfo(e) {

                this.navIndex +=1
                this.project_app_num = e
                /*this.levelOne = {
                    ...e
                }
                this.levelOne.project_code = this.project_code*/
            },
            // 保存的图片删除
            deleteUpload(key, index) {
                this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.uploadList[index].splice(key, 1)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 新增参建单位输入
            typeThreeInput(e, type, index) {
                if (type == '1') {
                    this.addList[index].type = e
                } else {
                    this.addList[index].name = e
                }
            },
            // 删除所在行
            // deleteList(index) {
            // 	if (this.addList.length === 1) {
            // 		this.$message.error(`至少填写一条参建信息`)
            // 		return
            // 	}
            // 	this.addList.splice(index, 1)
            // },
            // 删除行
            deleteList(index, type) {
                const number = this.addList.length + this.oldAddList.length
                if (number === 1) {
                    this.$message.error(`至少填写一条参建信息`)
                    return
                }
                if (type === '1') {
                    // 例旧信息
                    this.oldAddList.splice(index, 1)
                } else {
                    this.addList.splice(index, 1)
                }

            },
            // 新增参建单位
            addInstall() {
                this.addList.push({})
            },
            // 预览
            showPriv(e) {

                console.log(123123123)
                console.log(e)

                window.open(e.stored_path);
            },
            // 上传文件附件保存
            async setUploadFile() {
                let newArray = this.uploadList.filter(function(s) {
                    return s && s.length
                });

                let project_app_num1 = this.project_app_num

                if (!project_app_num1) {
                    this.$message.error('请先提交基本信息')
                    return
                }
                if (!newArray.length) {
                    this.$message.error('请先上传文件')
                    return
                }
                if (newArray.length < 2) {
                    this.$message.error('至少上传两条')
                    return
                }
                if(newArray.length < 10 && this.projectType === '0'){
                    this.$message.error('所有的内容必传哦')
                    return
                }


                if(newArray.length < 6 && this.projectType === '3'){
                    this.$message.error('所有的内容必传哦')
                    return
                }

                if(newArray.length < 5 && this.projectType === '2'){
                    this.$message.error('所有的内容必传哦')
                    return
                }

                if(newArray.length < 6 && this.projectType === '1'){
                    this.$message.error('所有的内容必传哦')
                    return
                }


                if (this.projectType === '2') {
                    if (!this.uploadList[1]) {
                        this.$message.error('项目管理成果论文必传')
                        return
                    }
                }

                let canSubmit  = 0 ;
                let dataJson = []
                this.uploadList.forEach((items, key) => {
                    items.forEach((item, index) => {
                        let data = {}
                        data['data_name'] = item.name ? item.name : item.data_name
                        data['type'] = key + 1
                        data['stored_path'] = item.url ? item.url : item.stored_path

                        if((key + 1) ==2 ){
                            canSubmit = 1 ;
                        }
                        dataJson.push(data)
                    })
                })


                if(canSubmit ==0 ){

                    this.$message.error('工法文本内容需要上传')
                    return
                }

                const params = {
                    dataJson: dataJson,
                    project_app_num: project_app_num1
                }
                await getUploadFile({
                    data: params,
                    success: res => {
                        // console.log(res)
                        if (res.code === 200) {
                            /*this.$message({
                                message: res.msg + ',现在可以确认提交',
                                type: 'success'
                            });
                            this.allSubmit = true*/

                            this.showScore()

                        } else {
                            this.$message.error(res.msg)
                        }
                    }
                })
            },

            async showScore() {

                const params = {
                    project_app_num: this.project_app_num
                }
                await sureSubmit({
                    data: params,
                    success: res => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });

                            //this.dialogVisible = false
                            setTimeout(() => {
                                this.$router.go(-1)
                            }, 1500)
                        } else {
                            this.$message.error(res.msg)
                        }
                    }
                })

            },

            //接受点击上传回穿
            submitSuccess(e) {
                if (this.uploadList[this.clickIndex]) {
                    let newList = [...this.uploadList[this.clickIndex], ...e]
                    this.$set(this.uploadList, this.clickIndex, newList)
                    return
                }
                this.$set(this.uploadList, this.clickIndex, e)
            },
            // 切换tab栏/
            changeTab(index) {

                this.navIndex = index
                /*if(this.makeShow >1){
                    this.navIndex = index
                }else{

                    if(this.isAdd ==1){
                        this.$message.error('还没完成阅读')
                    }
                }*/

            },
            // 获取必填警示
            requireSubmit(params, nameList) {
                //如果数据是对象形式
                let upString = []
                Object.keys(params).forEach((item, index) => {
                    if (params[item] == '' || params[item] == undefined || params[item] == null) {
                        if (nameList[item]) {
                            upString.push(item)
                        }
                    }
                })
                if (!upString.length) {
                    return false
                } else {
                    this.$message.error(`${nameList[upString[0]]}未填写`)
                    return true
                }
                // 如果数据是数组形式
            },

            // 获取项目明细
            async getProjectdetail(project_code,isAdd =0) {
                await getProjectDetail({
                    data: {
                        project_code,
                        isAdd,
                        type:8,
                    },
                    success: (res) => {
                        // console.log('获取项目明细', res.data)
                        // 基本信息

                        if(res.data.company){
                            this.newform = res.data.company
                        }

                        if(isAdd == 0 && res.data.basicMsg.complete_enp){

                             console.log('xxx')
                             console.log(res.data.basicMsg.complete_enp)
                            this.newform2 = res.data.basicMsg.complete_enp
                            this.newform3 = res.data.basicMsg.complete_enp

                        }else{
                            if(res.data.contact_man){
                                this.newform2 = res.data.contact_man
                            }
                        }

                        if (res.data.basicMsg) {

                            this.makeShow = 2;

                            this.basicMsg = res.data.basicMsg

                            this.textarea = this.basicMsg.personal_resume
                            this.textarea2 = this.basicMsg.personal_resume2

                            if (this.basicMsg.participating_units) {
                                this.oldAddList = JSON.parse(this.basicMsg.participating_units)
                            }
                            this.project_app_num = res.data.basicMsg.project_application_id

                            this.basicMsg.project_code =  res.data.project_code

                            // 获奖信息需要数据
                            if (this.projectType === '0' || this.projectType === '1') {
                                let number = 0
                                this.levelTwo.awardJson = this.levelTwo.awardJson.map((item, index) => {
                                    item.project_app_num = this.project_app_num
                                    item.pa_award_type = number++
                                    return item
                                })
                            }
                            if (this.projectType === '6') {
                                let number = 0
                                this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
                                                                                       index) => {
                                    item.project_app_num = this.project_app_num
                                    item.pa_award_type = number++
                                    return item
                                })
                            }
                            if (this.projectType === '3') {
                                this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
                                                                                       index) => {
                                    item.project_app_num = this.project_app_num
                                    // 先进企业
                                    if (index < 3) {
                                        item.pa_award_type = 0
                                    } else if (index > 2 && index < 6) {
                                        item.pa_award_type = 1
                                    } else if (index > 5 && index < 9) {
                                        item.pa_award_type = 2
                                    } else {
                                        item.pa_award_type = 3
                                    }
                                    return item
                                })
                            }
                        }
                        // 获奖信息
                        if (res.data.award_list) {
                            this.awardMsg = res.data.award_list
                            // console.log('获取项目明细', res.data.award_list)
                        }
                        // 文件上传
                        if (res.data.data_list) {
                            const uploadList = res.data.data_list
                            let newUploadList = []
                            uploadList.forEach((item, index) => {
                                newUploadList[Number(item.type) - 1] = []
                            })
                            uploadList.forEach((item, index) => {
                                newUploadList[Number(item.type) - 1].push(item)
                            })
                            this.uploadList = newUploadList
                        }

                        this.basicParams = res.data

                        if(typeof res.data.pa_evaluate != "undefined" && res.data.pa_evaluate != null){
                            this.pdbForm = res.data.pa_evaluate
                        }

                        // 申报须知PDF
                        this.require_pdf_url = res.data.require_pdf_url
                        // 评选办法PDF
                        this.selection_pdf_url = res.data.selection_pdf_url
                    }
                })
            },
            // 提交获奖信息
            async getWinninginfo() {

                const params = {
                    awardJson: [...this.levelTwo.awardJson]
                }

                console.log(787878787878777878)
                console.log(params)

                // return

                const newParams = params.awardJson

                if (!this.project_app_num) {
                    this.$message.error('请先提交基本信息')
                    return
                }

                if (this.projectType === '0' || this.projectType === '6') {
                    // 优秀项目经理
                    for (let key in newParams) {
                        if (Object.keys(newParams[key]).length !== 5) {
                            this.$message.error(this.award_msg[key] + '未填写完整')
                            return
                        }
                    }
                } else if (this.projectType === '1') {
                    // 优秀建造师
                    for (let key in newParams) {
                        if (key === '0') {
                            // 5正常  3测试
                            // 4正常  2测试
                            // 5>3
                            if (Object.keys(newParams[key]).length !== 5) {
                                this.$message.error(this.award_msg[key] + '未填写完整')
                                return
                            }
                        } else {
                            const newarray = []
                            for (let key in newParams) {
                                if (key > 0) {
                                    // 0>2
                                    if (Object.keys(newParams[key]).length > 2) {
                                        this.check = true
                                        newarray.push(true)
                                    } else {
                                        newarray.push(false)
                                    }
                                }
                            }
                            // 一个true都没有，就是都没填，有一个true就说明填了，未知是否填写完整
                            if (newarray.indexOf(true) === -1) {
                                this.check = false
                            }
                            if (!this.check) {
                                this.$message.error('请至少选择一项进行填写')
                                return
                            }
                            // 第一个数只能是5或者2，其他数不能为3
                            // [[5,2,2],[5,4,2],[5,2,4],[5,4,4],[5,4,2],[2,4,2],[2,4,4],[2,2,4]]
                            const newNun = []
                            newParams.forEach((items, index) => {
                                if (index > 0) {
                                    newNun.push(Object.keys(items).length)
                                }
                            })
                            if ((newNun[0] === 5 || newNun[0] === 2) && (newNun[1] != 3) && (newNun[2] != 3)) {} else {
                                if (key === '1') {
                                    // 如果填写了
                                    if (Object.keys(newParams[key]).length) {
                                        // console.log(Object.keys(newParams[key]).length)
                                        if (Object.keys(newParams[key]).length !== 5) {
                                            this.$message.error(this.award_msg[key] + '未填写完整')
                                            return
                                        }
                                    }
                                } else {
                                    if (Object.keys(newParams[key]).length) {
                                        // console.log(Object.keys(newParams[key]).length)
                                        if (Object.keys(newParams[key]).length !== 4) {
                                            this.$message.error(this.award_msg[key] + '未填写完整')
                                            return
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else if (this.projectType === '3') {
                    // 先进企业
                    // 当处于先进企业状态下，0-2是质量获奖情况、3-5安全文明情况、6-8科技、成果、9-11信用建设
                    console.log(newParams)
                    for (let key in newParams) {
                        if (key < 6) {
                            // 5正常  3测试
                            // 4正常  2测试
                            if (Object.keys(newParams[key]).length !== 5) {
                                this.$message.error(this.award_msg[key] + '未填写完整')
                                return
                            }
                        } else {
                            if (Object.keys(newParams[key]).length !== 4) {
                                this.$message.error(this.award_msg[key] + '未填写完整')
                                return
                            }
                        }
                    }
                }


                params.project_app_num = this.project_app_num

                await saveQua({
                    data: params,
                    success: (res) => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            // 自定义判断获奖信息 题没提交成功
                        } else {
                            this.$message.error(res.msg)
                        }
                    },
                    fail: (err) => {
                        console.log(err)
                    }
                })
            },
            // 模板下载弹窗
            upShow(type, index) {
                this.clickIndex = index
                if (type === 'muban') {
                    const params = {
                        type,
                        download: this.modelList
                    }
                    this.$refs['download'].showAdd(params)
                } else if (type === 'tips') {
                    const params = {
                        type,
                        project_app_num: this.project_app_num
                    }
                    this.$refs['download'].showAdd(params)
                } else {

                    sessionStorage.setItem('dataUpload',index);

                    if (this.projectType === '2' && index === 1) {
                        const params = {
                            type,
                            project: true,
                        }
                        this.$refs['download'].showAdd(params)
                    } else {
                        const params = {
                            type,
                            project_app_num: this.project_app_num
                        }
                        this.$refs['download'].showAdd(params)
                    }
                }
            },


            async basicInfo3(){

                this.navIndex += 1

                await setAdvanceInfoGfEnp({
                    data:{
                        form1 :this.newform,
                        form2 :this.newform2,
                        form3 :this.newform3,
                        project_app_num :this.project_app_num,

                    },
                    success: res => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });

                        }else{

                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                        }


                    }
                })
            },


            // 基本信息申报
            async basicInfo() {
                const params = {
                    ...this.levelOne
                }

                // 验证各个工程的表单

                console.log(params)

                if (this.requireSubmit(params, this.formName)) {
                    return
                }

                await setAdvanceInfoGF({
                    data: params,
                    success: res => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            this.project_app_num = res.data.project_app_num
                            this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
                                                                                   index) => {
                                item.project_app_num = this.project_app_num
                                // 先进企业
                                if (index < 3) {
                                    item.pa_award_type = 0
                                } else if (index > 2 && index < 6) {
                                    item.pa_award_type = 1
                                } else if (index > 5 && index < 9) {
                                    item.pa_award_type = 2
                                } else {
                                    item.pa_award_type = 3
                                }
                                return item
                            })
                        } else {
                            if (res.data.project_app_num) {
                                this.project_app_num = res.data.project_app_num
                                let number = 0
                                this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
                                                                                       index) => {
                                    item.project_app_num = this.project_app_num
                                    // 先进企业
                                    if (index < 3) {
                                        item.pa_award_type = 0
                                    } else if (index > 2 && index < 6) {
                                        item.pa_award_type = 1
                                    } else if (index > 5 && index < 9) {
                                        item.pa_award_type = 2
                                    } else {
                                        item.pa_award_type = 3
                                    }
                                    return item
                                })
                                console.log(this.levelTwo.awardJson)
                            }
                            this.$message.error(res.msg)
                        }
                    }
                })

            },
            // 输入基本信息
            labelInput(e, name) {
                this.newform[name] = e
            },

            // 输入基本信息
            labelInput2(e, name) {
                this.newform2[name] = e
            },


            labelInput3(e, name) {
                this.newform3[name] = e

            }
        }
    }
</script>

<style scoped>
    /* 每个上传文件的样式 */
    .inner_upload {
        position: relative;
        min-height: 40px;
        margin: 0 10px;
        /* width: 100px; */
        /* overflow: scroll; */
    }

    .inner_upload p {
        color: #1890FF;
    }

    .tip{
        height: 40px;
    }

    .inner_upload img {
        border-radius: 50%;
        position: absolute;
        right: 0;
        top: 0;
        width: 15px;
        height: 15px;
        cursor: pointer;
    }


    .headView_top_btn {
        position: relative;
        margin-right: 125px;
    }

    .btnTips {
        margin-top: 10px;
        display: flex;
        position: absolute;
        width: 350px;
        align-items: center;
    }

    .btnTips p {
        margin-left: 10px;
        font-size: 13px;
        color: #FE2c54;
    }

    /* 上传样式 */
    .uploadBtn {
        margin-top: 60px;
        margin-bottom: 60px;
        display: flex;
        margin-left: 41.5%;
    }

    .uploadBtn button {
        width: 140px;
    }

    .uploadHead {
        display: flex;
        position: absolute;
        align-items: center;
        left: 255px;
    }

    .uploadHead p {
        margin-left: 10px;
        color: #1890FF;
        cursor: pointer;
    }

    .uploadList {
        border: 1px solid #f0f0f0;
        width: 90%;
        margin-top: 30px;
        margin-left: 5%;
    }


    .uploadList_head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 40px;
        padding: 0 40px 0 10px;
        line-height: 40px;
        font-size: 14px;
        flex-wrap: wrap;
        border-bottom: 1px solid #f0f0f0;
    }

    .uploadList_head p {
        text-align: left;
    }

    .head_list {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .head_list p {
        margin-left: 10px;
    }

    .head_list p:hover {
        color: #1890FF;
        text-decoration: underline;
    }

    .uploadList_mid {
        width: 90%;
        min-height: 30px;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        justify-content: flex-start;
    }

    .uploadList_mid p {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        text-align: left;
        text-indent: 2em;
        padding: 10px;
    }

    .uploadList_bot {
        width: 70%;
        min-height: 30px;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        justify-content: flex-start;
    }

    .uploadList_bot p {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        color: #1890FF;
        text-decoration: underline;
        margin: 0 20px;
        cursor: pointer;
    }

    /* 上传样式 */
    .uploadContent {
        padding-bottom: 60px;
    }

    .inputList {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .titleLeft {
        margin-left: 50px;
    }

    .view_head {
        font-size: 18px;
        font-weight: 600;
        margin-top: 20px;
    }

    .midflex {
        display: flex;
        width: 90%;
        height: 50px;
        margin-left: 5%;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #eee;
    }

    .newAddBtn {
        width: 100%;
        display: flex;
        height: 70px;
        align-items: center;
        justify-content: center;
    }

    .headView {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
    }

    .headView_top {
        width: 1350px;
        display: flex;
        justify-content: space-between;
    }

    .headView_top button {
        width: 100px;
        height: 35px;
        background-color: #1890FF;
        color: white;
        line-height: 35px;
        cursor: pointer;
    }

    .applyTitle {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #000000;
    }

    .applyTitle {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #000000;
    }

    .headClass {
        display: flex;
        margin-top: 10px;
    }

    .headClass p {
        margin-right: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }

    /* 申报 */
    .content_view {
        margin-top: 20px;
        max-width: 1350px;
        min-height: 350px;
        /* min-height: 750px; */
        display: flex;
        border: 1px solid #f0f0f0;
    }

    .contentLeft {
        width: 200px;
    }

    .contentLeft p {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #333333;
        background-color: #fafafa;
        cursor: pointer;
    }

    .contentRight {
        width: 100%;
    }

    .tabActive {
        background: #e6f7ff !important;
        color: #6ea7ff !important;
        border-right: 2px solid #0077ff;
    }

    .content_btn {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        margin-bottom: 30px;
    }

    .content_btn p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FE2C54;
    }

    .content_btn button {
        width: 150px;
        margin-top: 40px;
        margin-left: 440px;
    }

    .specialView {
        width: 720px;
        display: flex;
        align-items: center;
    }

    .specialView input {
        margin-left: 20px;
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        letter-spacing: 1px;
        border-bottom: 1px solid #DBDBDB;
    }

    .specialView input::placeholder {
        color: #B5B5B5;
    }

    .dash_bottom {
        margin-top: 30px;
        margin-bottom: 20px;
        border-bottom: 1px solid #DBDBDB;
        margin-left: 120px;
        height: 1px;
        width: 81%;
    }

    /* gridtable */
    table.gridtable {
        font-family: verdana,arial,sans-serif;
        font-size:14px;
        color:#333333;
        border-width: 1px;
        border-color: #666666;
        border-collapse: collapse;
        margin: auto;
    }
    table.gridtable th {
        border-width: 1px;
        padding: 12px;
        border-style: solid;
        border-color: #666666;
        background-color: #dedede;
    }
    table.gridtable td {
        border-width: 1px;
        padding: 22px;
        border-style: solid;
        border-color: #666666;
        background-color: #ffffff;
    }

    table.gridtable .el-input__inner{
        border: none;
    }

    /* /gridtable */

</style>